module.exports = __webpack_public_path__ + "img/52.c2169518.jpg";